// extracted by mini-css-extract-plugin
module.exports = {"ForgotPasswordForm":"ForgotPasswordForm_ForgotPasswordForm__q2Z5c","TextColor":"ForgotPasswordForm_TextColor__b_Ckj","Link":"ForgotPasswordForm_Link__JZXut"};